import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import CloseIcon from '@atlaskit/icon/core/close';
import { Flex, Stack, Text } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

type Props = {
	title: string;
	description?: string;
	onClose: () => void;
};
const Header = ({ title, onClose, description }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Stack>
			<Flex justifyContent="space-between">
				<Heading size="medium" as="h3">
					{title}
				</Heading>
				<Tooltip content={formatMessage(messages.closeSidebarNonFinal)} position="top">
					<IconButton
						appearance="subtle"
						icon={CloseIcon}
						label={formatMessage(messages.closeSidebarNonFinal)}
						onClick={onClose}
						isTooltipDisabled={false}
					/>
				</Tooltip>
			</Flex>
			{description !== undefined && <Text as="p">{description}</Text>}
		</Stack>
	);
};

export default Header;
